import states from "~~/data/states";

const baseURL = "https://dev.virtualearth.net/REST/v1";

export function useBingApiKey() {
  const config = useRuntimeConfig();
  let availableKeys = config.public.bingApiKeys;

  function getKey() {
    const index = Math.floor(Math.random() * availableKeys.length);
    return availableKeys[index];
  }

  function invalidateKey(key) {
    availableKeys.splice(availableKeys.indexOf(key), 1);
  }

  return { getKey, invalidateKey };
}

export async function useFetchLocation({ latitude, longitude, lang = "en-US" }) {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    throw new Error("Invalid coordinates");
  }
  const { getKey, invalidateKey } = useBingApiKey();
  const key = getKey();
  const params = {
    key: getKey(),
    includeNeighborhood: 1,
    culture: lang,
  };
  const url = computed(() => `/Locations/${round(latitude, 4)},${round(longitude, 4)}`);
  return useLazyFetch(url, {
    baseURL,
    params,
    key: url.value,
    transform: (response) => {
      const address = response.resourceSets[0].resources[0]?.address;
      let adminDistrict = address?.adminDistrict;
      if (adminDistrict in states) {
        adminDistrict = states[address.adminDistrict].name;
      }
      let formattedAddress = address?.formattedAddress;
      if (address?.countryRegion.includes("United States")) {
        formattedAddress = formattedAddress.replaceAll(/,\s(?!([A-Z]{2}))/g, "<br/>");
      }
      const coordinates = `${round(latitude, 4)}, ${round(longitude, 4)}`;
      return {
        ...address,
        intersectionName: address?.intersection?.displayName,
        adminDistrict,
        adminDistrict2: address?.adminDistrict2?.replace("Co.", "County"),
        coordinates,
        formattedAddress,
      };
    },
    onResponseError({ response }) {
      if (response.status === 403) {
        invalidateKey(key);
      }
    },
  });
}

export async function useFetchElevation({ latitude, longitude }) {
  // uncomment to temporarily override bing with custom elevation service
  return useFetchAPIElevation({ latitude, longitude });

  // const { getKey, invalidateKey } = useBingApiKey();

  // if (!isNumber(latitude) || !isNumber(longitude)) {
  //   throw new Error("Invalid coordinates");
  // }
  // const key = getKey();

  // if (!key) {
  //   return useFetchAPIElevation({ latitude, longitude });
  // }

  // const params = computed(() => ({
  //   key,
  //   points: `${round(latitude, 4)},${round(longitude, 4)}`,
  // }));
  // const response = await useLazyFetch("/Elevation/List/", {
  //   baseURL,
  //   params,
  //   transform: (response) => response.resourceSets[0]?.resources[0]?.elevations[0],
  // });
  // if (response.error.value) {
  //   if (response.error.value.statusCode == 403) {
  //     invalidateKey(key);
  //     return useFetchAPIElevation({ latitude, longitude });
  //   }
  // }
}

export async function useFetchAutosuggestions(query, { lang = "en-US" } = { lang: "en-US" }) {
  const { getKey, invalidateKey } = useBingApiKey();
  const key = getKey();
  const params = computed(() => ({
    key,
    culture: lang,
    query,
    maxResults: 5,
  }));

  return useLazyFetch("/Autosuggest/", {
    baseURL,
    params,
    transform: (response) => response.resourceSets[0].resources[0]?.value,
    onResponseError({ response }) {
      if (response.status === 403) {
        invalidateKey(key);
      }
    },
  });
}

// async function getLocations({ query, latitude = null, longitude = null, lang = "en-US" }) {
//   let params = {
//     key: getKey(),
//     includeNeighborhood: 1,
//     verboseplacenames: true,
//     culture: lang,
//     query,
//   };
//   if (latitude !== null && longitude !== null) {
//     params.location = `${latitude},${longitude}`;
//   }
//   let response = await axios.get(`${baseUrl}/Locations/`, { params });
//   let data = response.data.resourceSets[0].resources;
//   return data;
// }

export async function getLocationForAutosuggestion(item, { lang = "en-US" } = { lang: "en-US" }) {
  const { getKey, invalidateKey } = useBingApiKey();

  const params = computed(() => ({
    key: getKey(),
    includeNeighborhood: 1,
    culture: lang,
    query: item?.name,
    ...item?.address,
  }));
  return useLazyFetch("/Locations/", {
    baseURL,
    params,
    transform: (response) => response.resourceSets[0].resources[0],
    onResponseError({ response }) {
      if (response.status === 403) {
        invalidateKey(key);
      }
    },
  });
}
